import styled from 'styled-components'

const H6 = styled.h6`
  font-family: 'Montserrat', sans-serif;
  margin: 0;
  font-size: 1em;
`
export default H6
